<template>
    <section>
            <div class="modal-card" style="width: 720px">
                <header class="modal-card-head">
                    <p class="modal-card-title">Eliminar Compromiso</p>
                    <button type="button" class="delete" @click="$emit('close')" />
                </header>
                <section class="modal-card-body">
                    <div class="columns">
                        <div class="column is-1">
                            <b-icon icon="times-circle" size="is-large" type="is-danger" />
                        </div>
                        <div class="column content">
                            <p>
                                ¿Está seguro que desea eliminar el compromiso <b>{{ commitment.commitment_index }}</b>?<br>
                                Actividad comprometida: <b>{{ commitment.alt_name_activity }}</b><br>
                                Tipo de horas: <b>{{ commitment.is_weekly_hours ? 'Semanales' : 'Semestrales' }}</b><br>
                                Horas comprometidas primer semestre: <b>{{ commitment.hours_committed_semester_1 }}</b><br>
                                Horas comprometidas segundo semestre: <b>{{ commitment.hours_committed_semester_2 }}</b><br>
                            </p>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot is-flex is-justify-content-space-between">
                    <b-button label="Cancelar" @click="$emit('close')" />
                    <b-button label="Eliminar" type="is-danger" icon-left="trash"
                        @click="$emit('delete'); $emit('close')" />
                </footer>
            </div>
    </section>
</template>

<script>
export default {

    name: 'ConfirmDeleteCommitment',

    props: {
        commitment: {
            type: Object,
            required: true
        },
    },

}
</script>